import { normalizeBaseUrl } from "shared-utils";
import { Api as UserAccountApi } from "../generated/UserAccountApi";
import config from "../config";
import { createAxiosRequestInterceptors } from "../axios/axios-interceptors";

const userAccountApi = new UserAccountApi({
  baseURL: normalizeBaseUrl(config.userAccountApiUrl),
});

createAxiosRequestInterceptors(userAccountApi.instance);

export default userAccountApi;
